import { Tab, Tabs } from "@mui/material";
import { withStyles } from '@mui/styles';
import { default as React } from "react";
import { useMediaQuery } from 'react-responsive';
import * as styleGlobal from "../infra/styleGlobal";
import { Text, View } from "./index";
import PopMenu from "./PopMenu";
import StyleSheet from "./StyleSheet";

function renderPopMenu({ tabs, pushTo }) {
  let lista = [];
  tabs.forEach(item => {
    lista.push({
      text: item.nome,
      tela: item.tela,
      index: item.index,
      close: true,
      onClick: () => {
        pushTo(item.index)
      }
    })
  });
  return (
    <PopMenu
      index={0}
      color={"black"}
      text={"Menu Tabs"}
      lista={lista}
    />
  )
}

const TitleBarTabs = (props = {}) => {

  let { to = {}, titulo, children, showBack = true, onClickBack, modal, classes, tabs, pushTo, tabvalue, styleCard, subheader } = props;
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: " + (styleGlobal.breakMobile - 1) + "px)" })
  const isdekstop = useMediaQuery({ query: "(min-width: " + (styleGlobal.breakMobile) + "px)" })
  function returnBody() {
    return (
      <View style={{ padding: 15 }} >
        {tabs && isdekstop && tabs.length > 0 && <View style={{ backgroundColor: styleGlobal.color3, paddingTop: 12, paddingBottom: 12, paddingLeft: 8, paddingRight: 8, borderRadius: 5 }}>
          <Tabs
            value={tabvalue}

            indicatorColor={"#444444 "}
            TabIndicatorProps={{ style: { backgroundColor: "#444444 " } }}
            scrollButtons="on"
            variant="scrollable"
            onChange={(event, index) => {
              pushTo(index);
            }}
          >
            {tabs.map((prop, key) => {
              return <Tab key={key} label={<Text className={classes.lbltab} >{prop.nome}</Text>} />
            })}
          </Tabs>
        </View>
        }
        {
          tabs && isTabletOrMobile && tabs.length > 0 &&
          renderPopMenu({ tabs, pushTo })
        }

        <View style={{ height: 1, backgroundColor: styleGlobal.color3, marginTop: 10, marginBottom: 10 }}></View>

        {children}
      </View >
    )
  }
  return (returnBody())
};
var styles = StyleSheet.create({
  fragment2: { flexDirection: "row", zIndex: 888 },
})

export const gsUI = theme => ({
  lbltab: {
    color: "#444444",
    fontSize: 17,
    textTransform: "none",
    // fontWeight: 'bold',
    [theme.breakpoints.down(styleGlobal.breakMobile)]: {
      fontSize: 12
    },
  },
});
export default (withStyles(gsUI)(TitleBarTabs));


 //exemplo de tab
/*

 this.tabs =  //tem q ser antes do state
 [
   { nome: "Categorias e Produtos", tela: "teste1", index: 0 },
   { nome: 'Configurações de Variações e Opções', tela: "teste2", index: 1 },
   { nome: 'Grupos de Produtos/Horários', tela: "teste3", index: 2 },
 ]
 this.state = { user: {}, index: actions.tabsTelas(this) || 0, };
}
   <View>
        <TitleBar showBack={false} titulo={"Produtos e Categorias"}
          tabs={this.tabs}
          pushTo={(index) => { actions.pushToTab({ index, path: "filial/" + id_filial + "/empresa/" + id_empresa + "/catprods/", componente: this }); this.setState({ index: index }) }}
          tabvalue={index}
        >
          {index == 0 &&
            <Text>0</Text>
          }
             {index == 1 &&
            <Text>1</Text>
          }

          ...etc
*/